


































import Vue from 'vue'
import '@/assets/global.scss'
import Header from './components/Header.vue'
export default Vue.extend({
  components: { Header },
  data: () => ({
    tab: '/',
  }),
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    },
  }
})
